<template>
  <v-dialog v-if="value" v-model="value" persistent scrollable max-width="450">
    <v-card tile>
      <v-card-title>图表导出设置</v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12">
            <v-radio-group v-model="formData.type" row hide-details>
              <v-radio v-for="(item,index) in items" :key="index" :label="item.name" :value="item.code"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12">
            <v-radio-group label="分辨率" v-model="formData.dpi" row hide-details @change="onDpiChange">
              <v-radio v-for="(item,index) in coder_DPI" :key="index" :label="item.name" :value="item.code"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12" class="mt-4">
            尺寸：{{formData.width}} x {{formData.height}}
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" text @click="onCancel">取消</v-btn>
        <v-btn color="primary" v-one-click @click="onOk">确定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ['value'],
  data () {
    return {
      items: [
        { code: 'image/png', name: 'PNG' },
        { code: 'image/jpeg', name: 'JPG' },
        { code: 'image/tiff', name: 'TIFF' },
        { code: 'image/svg-xml', name: 'SVG' },
        { code: 'application/pdf', name: 'PDF' }
      ],
      coder_DPI: [
        { code: 72, name: '72' },
        { code: 150, name: '150' },
        { code: 300, name: '300' }
      ],
      formData: {
        type: 'image/png',
        width: null,
        height: null,
        dpi: 72,
        sourceWidth: null,
        sourceHeight: null
      }
    }
  },
  methods: {
    onCancel () {
      this.$emit('input', false);
    },
    onOk () {
      this.$emit('ok', this.formData);
    },
    onDpiChange () {
      this.setSize();
    },
    setSourceSize (size) {
      this.formData.sourceWidth = size.width;
      this.formData.sourceHeight = size.height;
      this.setSize();
    },
    setSize () {
      let w = this.formData.sourceWidth, h = this.formData.sourceHeight;
      console.log(w, h);
      // 默认为72分辨率
      let scale = this.formData.dpi / 72;
      let nw = parseInt(w * scale), nh = parseInt(h * scale);
      this.$set(this.formData, 'width', nw);
      this.$set(this.formData, 'height', nh);
    }
  }
}
</script>